var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-fluid",attrs:{"src":"/img/widgets/opengiftcard.jpg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }